export const actions = {
  async aboutUs(state) {
    const res = await this.$axios.get('/pages/about-us')
    return res.data
  },
  async distpatchPolicies(state) {
    const res = await this.$axios.get('/pages/dispatch-policies')
    return res.data
  },
  async exchangePolicies(state) {
    const res = await this.$axios.get('/pages/exchange-return-policies')
    return res.data
  },
  async privacyPolicies(state) {
    const res = await this.$axios.get('/pages/privacy-policies')
    return res.data
  },
  async generalPolicies(state) {
    const res = await this.$axios.get('/pages/general-policies')
    return res.data
  },
  async generalConditions(state) {
    const res = await this.$axios.get('/pages/general-conditions')
    return res.data
  },
  async getEvent(state) {
    const res = await this.$axios.get('/pages/events')
    return res.data
  },
  async getOneEvent(state, slug) {
    const res = await this.$axios.get('/events/' + slug)
    return res.data
  },
  async getEventSelects(state, slug) {
    const res = await this.$axios.get('/events/selects')
    return res.data
  },
  async sendEventReservation(state, data) {
    const res = await this.$axios.post('/events', data)
    return res.data
  },
  async sendReservation(state, data) {
    const res = await this.$axios.post('/reservations', data)
    return res.data
  },
  async getLayoutFooter(state, event) {
    const res = await this.$axios.get('/pages/layout')
    return res.data
  },
  async sendNewsletter(state, data) {
    const res = await this.$axios.post('/newsletter', data)
    return res.data
  },
  async sendContact(state, data) {
    const res = await this.$axios.post('/contact', data)
    return res.data
  },
  async sendContactCompany(state, data) {
    const res = await this.$axios.post('/company-contact', data)
    return res.data
  },
  async getDataContact(state, data) {
    const res = await this.$axios.get('/pages/need-help')
    return res.data
  },
  async getElementsByFilter(state, data) {
    const res = await this.$axios.get(data)
    return res.data
  },
  async getOrderTraking(state, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get('/order-tracking?' + filters)
    return res.data
  },
  async getBlogPage(state, data) {
    const res = await this.$axios.get('/pages/blog')
    return res.data
  },
  async get404Page(state, data) {
    const res = await this.$axios.get('/pages/not-found')
    return res.data
  },
  async getContactPersonThankYouPage(state, data) {
    const res = await this.$axios.get('/pages/thank-you-page-contact-us')
    return res.data
  },
  async getContactCompanyThankYouPage(state, data) {
    const res = await this.$axios.get(
      '/pages/thank-you-page-company-contact-us'
    )
    return res.data
  },
  async getReservationPage(state, data) {
    const res = await this.$axios.get('/pages/reservation')
    return res.data
  },
  async getReservationTablePage(state, data) {
    const res = await this.$axios.get('/pages/table-wine-bar-reservations')
    return res.data
  },
  async getReservationThankYouPage(state, data) {
    const res = await this.$axios.get('/pages/thank-you-page-reservation')
    return res.data
  },
}
